// removed by extract-text-webpack-plugin
module.exports = {"toggle":"TenantEnabledToggle__toggle___2EQj3"};